<template>
    <div>
      <!-- Form Group -->
      <div class="form-group mb-3">
        <label for="location" class="form-label">
          <i class="bi bi-geo-alt"></i> City
        </label>
        <input
          type="text"
          id="location"
          v-model="location"
          class="form-control"
          placeholder="Enter Location Name"
          required
        />
        <div v-if="errorMessage" class="alert alert-danger">
          <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
        </div>
        <div v-if="successMessage" class="alert alert-success">
          <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
        </div>
        <button @click="submitForm" class="btn btn-primary"><i class="bi bi-check2"></i> Save</button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        location: '',
        successMessage: null,
        errorMessage: null,
      };
    },
    methods: {
      async submitForm() {
        this.successMessage = null; // Reset success message
        this.errorMessage = null;   // Reset error message
  
        try {
          const response = await axios.post('/insert-location', {
            location: this.location
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            }
          });
  
          // Handle successful submission
          this.successMessage = response.data.message; // Set the success message
          this.location = ''; // Clear the form
        } catch (error) {
          if (error.response && error.response.data) {
            // Handle errors from Laravel
            this.errorMessage = error.response.data.message || 'An error occurred.';
          } else {
            this.errorMessage = 'An error occurred.';
          }
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add any specific styles you need */
  </style>
  